import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const cssClass = 'btn';


export default /*#__PURE__*/_defineComponent({
  __name: 'VButton',
  props: {
  appearance: {
    type: String,
    default: 'solid',
    validator: (appearance: string) => ['solid', 'outline', 'control'].includes(appearance),
  },
  color: {
    type: String,
    default: 'primary',
    validator: (color: string) => ['primary', 'secondary', 'danger', 'success'].includes(color),
  },
  size: {
    type: String,
    default: 'medium',
    validator: (size: string) => ['small', 'square', 'medium', 'wide'].includes(size),
  },
  isLink: {
    type: Boolean,
    default: false,
  },
  href: {
    type: String,
    default: undefined,
  },
  target: {
    type: String,
    default: undefined,
  },
  /* TODO NEED TO REMOVE SOMETIMES; TOO MUCH BUTTONS HAS DIFFERENT VIEW */
  rounded: {
    type: Boolean,
    // eslint-disable-next-line vue/no-boolean-default
    default: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.isLink ? 'a' : 'button'), {
    type: "button",
    class: _normalizeClass([
      cssClass,
      `${cssClass}_${__props.appearance}`,
      `${cssClass}_${__props.color}`,
      `${cssClass}_${__props.size}`,
      { [`${cssClass}_rounded`]: __props.rounded },
    ]),
    href: __props.href,
    target: __props.target
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "href", "target"]))
}
}

})